import React from 'react';
import { PropTypes } from 'prop-types';
import { STable } from '@/customComponents/BuildingBlocks/SortableTable/SortableTable';

function GuestDayList(props) {
  const { days, selectedDays, selectDay, openGuestDay, selectable } = props;
  const rowMap = {
    guestDayId: {
      id: 'guestDayId',
      label: 'Guest Day ID'
    },
    guest: {
      id: 'guest',
      label: 'Guest'
    },
    date: {
      id: 'date',
      label: 'Date'
    },
    roomType: {
      id: 'roomType',
      label: 'Room'
    },
    inboundRate: {
      id: 'inboundRate',
      label: 'Inbound'
    },
    outboundRate: {
      id: 'outboundRate',
      label: 'Outbound'
    },
    status: {
      id: 'status',
      label: 'Status'
    }
  };

  const createRow = (day) => ({
    id: day.id,
    selected: selectedDays.indexOf(day.id) !== -1,
    onSelect: () => selectDay(day),
    columns: [
      {
        value: day.id,
        columnId: rowMap.guestDayId.id,
        label: (
          <button type="button" onClick={() => openGuestDay(day)}>
            {day.id}
          </button>
        )
      },
      {
        value: `${day.guest.lastName}, ${day.guest.firstName[0]}.`,
        columnId: rowMap.guest.id,
        label: `${day.guest.lastName}, ${day.guest.firstName[0]}.`
      },
      {
        value: day.startDate,
        columnId: rowMap.date.id,
        label: day.startDate
      },
      {
        value: day.room.roomType,
        columnId: rowMap.roomType.id,
        label: day.room.roomType
      },
      {
        value: day.inboundRate,
        columnId: rowMap.inboundRate.id,
        label: day.inboundRate
      },
      {
        value: day.outboundRate,
        columnId: rowMap.outboundRate.id,
        label: day.outboundRate
      },
      {
        value: day.status,
        columnId: rowMap.status.id,
        label: day.status
      }
    ]
  });

  return (
    <STable
      selectable={selectable}
      pagination
      showHeader
      hideHeaderCheckbox
      columns={Object.values(rowMap)}
      defaultSort={rowMap.guestDayId.id}
      rows={days.map((day) => createRow(day, selectedDays, selectDay, openGuestDay))}
    />
  );
}

GuestDayList.propTypes = {
  days: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  selectedDays: PropTypes.arrayOf(PropTypes.string),
  selectDay: PropTypes.func,
  openGuestDay: PropTypes.func,
  selectable: PropTypes.bool
};

GuestDayList.defaultProps = {
  selectable: false,
  selectedDays: [],
  selectDay: () => false,
  openGuestDay: () => false
};

export default GuestDayList;
